import { useRoute } from 'vue-router';
import { computed, ref } from 'vue';
import { useWindowSize } from '@vueuse/core';
import { canHaveGlobalBanner } from '@/global-banner/global-banner.utils';
import {
    sideNavCollapsedWidth,
    sideNavExpandedWidth,
    sideNavCollapsedWidthSmallScreen,
    topNavHeight,
    newUiShellMargin,
    newUiShellBorderWidth,
    newUiShellBorderRadius,
} from '@/constants/nav';
import useUiVersion from '@/common/use/use-ui-version/use-ui-version';
import { useLeftNavStore } from '@/stores/left-nav.store';
import { shouldShowNavItems } from '@/vue-router/route.utils';

export function useFixedStyles () {
    const currentRoute = useRoute();
    const { isNewUi } = useUiVersion();
    const leftNavStore = useLeftNavStore();

    const isNavExpanded = computed(() => leftNavStore.expanded);
    const topBannerHeight = computed(() => leftNavStore.topBannerHeight);
    const isTopBannerDismissed = computed(() => leftNavStore.isTopBannerDismissed);
    const shouldGlobalBannerShow = computed(() =>
        canHaveGlobalBanner({
            isTopBannerDismissed,
            currentRoute: currentRoute?.name,
        }),
    );
    const pendoPageRightMargin = ref(0);
    const { width: windowWidth } = useWindowSize();
    const isNewUiShellActive = computed(() => isNewUi.value && shouldShowNavItems(currentRoute, true));
    const newUiShellInset = computed(() => (isNewUiShellActive.value ? newUiShellMargin + newUiShellBorderWidth : 0));
    const topOffset = computed(() => {
        let top = newUiShellInset.value + topNavHeight;

        if (shouldGlobalBannerShow.value) {
            top += topBannerHeight.value;
        }

        return top;
    });

    const leftNavWidth = computed(() => {
        if (windowWidth.value < 992) {
            return sideNavCollapsedWidthSmallScreen;
        }

        return isNavExpanded.value ? sideNavExpandedWidth : sideNavCollapsedWidth;
    });

    const affixStyles = computed(() => {
        return {
            fixedStyles: {
                left: leftNavWidth.value + (isNewUiShellActive.value ? newUiShellBorderWidth : 0),
                right: pendoPageRightMargin.value + newUiShellInset.value,
                top: topOffset.value,
            },
            shouldAffix: true,
        };
    });

    const drawerStyles = computed(() => {
        return {
            top: topOffset.value,
            right: newUiShellInset.value,
            bottom: isNewUiShellActive.value ? newUiShellMargin : 0,
            pushDrawerShellChrome: isNewUiShellActive.value,
            pushDrawerShellBorderRadiusPx: newUiShellBorderRadius,
        };
    });

    const setPendoPageRightMargin = (value) => {
        pendoPageRightMargin.value = windowWidth.value - leftNavWidth.value - value;
    };

    return {
        leftNavWidth,
        affixStyles,
        drawerStyles,
        pendoPageRightMargin,

        setPendoPageRightMargin,
    };
}
